import { render, staticRenderFns } from "./CopperLayout.vue?vue&type=template&id=5054e4f4&scoped=true&"
import script from "./CopperLayout.vue?vue&type=script&lang=js&"
export * from "./CopperLayout.vue?vue&type=script&lang=js&"
import style0 from "./CopperLayout.vue?vue&type=style&index=0&id=5054e4f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5054e4f4",
  null
  
)

export default component.exports